"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * go to map location for specific map url
 * @param {String} mapUrl
 */

function goToMapURL(mapUrl) {
  window.open(mapUrl);
}
var _default = exports["default"] = goToMapURL;